import { Button, Card, CardBody, CardFooter, Select, SelectItem, Textarea } from "@nextui-org/react"
import { MainContainer } from "../../components"
import { ENUM_ACTYPE, ENUM_INPUT_TYPE, apiRoute, linksUrl } from "../../constants/enum"
import { useEffect, useState } from "react"
import NextInputBox from "../../components/InputBox"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"


const DeliveryAddress = () => {
    const { compCode } = useSelector((state) => state.company)
    const { partyAcId } = useSelector((state) => state.account)
    let [isUpdate, setIsUpdate] = useState(false);

    const { data: itemDelParty = [] } = useFetchWithBody({
        url: apiRoute.account.fetchAcByType,
        queryKey: "getAcTypeDelivery",
        inputData: {
            comp_code: compCode.join(","),
            ac_type: ENUM_ACTYPE.Delivery
        }
    })

    const onSuccessGetDelParty = (data) => {
        if (data && data.length > 0) {
            if (data && data.length > 0) {
                setIsUpdate(true);
                setFormData({
                    DeliveryID: data[0].D_ID,
                    DeliveryAddress: data[0].Del_Add
                })
            }
        }
        else {
            setIsUpdate(false);
        }

    }
    const { data = [], mutate: getDelParty } = usePost({
        url: apiRoute.account.fetchDelivery,
        queryKey: "getDeliveryParty",
        onSuccessTasks: onSuccessGetDelParty
    })
    const formField = {
        DeliveryID: "DeliveryID",
        DeliveryAddress: "DeliveryAddress"
    }

    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        acc[key] = "";
        return acc;
    }, {});

    let [formData, setFormData] = useState({
        ...emptyFormField
    })

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev, [name]: value
        })
        )
    }
    const handleSelectionChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev, [name]: value
        })
        )
    }

    useEffect(() => {
        if (data.length == 0) {
            if (partyAcId && partyAcId !== "") {
                getDelParty({
                    data: {
                        comp_code: compCode.join(","),
                        pac_id: partyAcId
                    }
                })

            }
        }
    }, [])



    const onSuccessTasks = (data) => {
        if (data) {
            toast.success(isUpdate ? "Delivery Address Updated Successfully " : "Delivery Address Assigned Successfully ", {
                position: "top-center"
            })
        }
    }
    const resetValues = () => {
        setFormData({})
    }
    const { isPending,mutate: funInsert } = usePost({
        url: apiRoute.account.addDelivery,
        queryKey: "insertDelivery",
        onSuccessTasks,
        resetValues
    })
    
    const handleSubmit = (e) => {
        e.preventDefault();
        funInsert({
            data: {
                d_id: formData.DeliveryID,
                del_add: formData.DeliveryAddress,
                comp_code: compCode.join(","),
                pac_id: partyAcId,
                rec_status: isUpdate ? 1 : 2
            }

        })
    }

    return (
        <div>
            <Card shadow="sm" radius="sm" className="mb-3 h-full">
                <form onSubmit={handleSubmit}>
                    <CardBody className="p-2">


                        <div className=" items-center gap-2 mb-5" >

                            <Select
                                name={formField.DeliveryID}
                                size="sm"
                                label="Delivery ID"
                                labelPlacement="outside"
                                placeholder="---select---"
                                selectionMode="single"
                                isRequired={true}
                                items={itemDelParty ? itemDelParty : []}
                                onChange={handleSelectionChange}
                                selectedKeys={[String([formData.DeliveryID])]}
                            >
                                {(list) => {
                                    return (
                                        <SelectItem key={list.AC_ID}>
                                            {list.AC_DESC}
                                        </SelectItem>)

                                }}
                            </Select>
                            <Textarea
                                value={formData.DeliveryAddress}
                                name={formField.DeliveryAddress}
                                label="Delivery Address"
                                labelPlacement="outside"
                                placeholder="Address"
                                size="sm"
                                className=""
                                onChange={handleInputChange}
                            />




                        </div>


                        <div>

                            <CardFooter className="flex justify-center">
                                <Button color="primary" type="submit" isLoading={isPending} >
                                    Submit
                                </Button>

                            </CardFooter>
                        </div>
                    </CardBody>
                </form>

            </Card>
        </div>
    )
}
export default DeliveryAddress